import React from "react";
import {
  DashboardEmptyState,
  HubTableTemplate,
} from "../../components";

const items = [
  { id: "workOrder", label: "WO #" },
  { id: "part", label: "Part" },
  { id: "customer", label: "Customer" },
  { id: "quantity", label: "Qty" },
  { id: "revenue", label: "Revenue" },
  { id: "createdBy", label: "Created By" },
];

const keys = [
  {
    variant: "blueBold",
    value: "workOrder",
    navigate: true,
    route: "works",
    id: "workOrder",
  },
  { value: "part.partNumber", defaultValue: "—" },
  { value: "customer.name", defaultValue: "—" },
  { value: "quantity", defaultValue: 0 },
  { value: "revenue", isCurrency: true },
  { value: "createdBy", isUser: true, userProps: { size: "18px" } },
];

export const RecentWorkOrdersTable = ({ rows = [], isLoading }) => {
  if (!isLoading && !rows.length) {
    return (
      <DashboardEmptyState
        icon="FileText"
        title="No recent work orders"
        subtitle="Work orders generated for batches will appear here."
      />
    );
  }
  return (
    <HubTableTemplate
      id="dashboard-recent-workorders"
      headerProps={{ items }}
      bodyProps={{ items: rows, keys }}
      isLoading={isLoading}
    />
  );
};

export default RecentWorkOrdersTable;
